import map from './map';
import center from './center';
import setMarkerEvent from './set-marker-event';
import {
  mapPin,
  mapPinFocus,
  markUnSelect,
  markUnSelectTrost,
  markSelectTrost,
  getIcon,
  markSelectInLink,
  markSelectInLinkSize,
} from '../img/pin';
import {
  getInfoOfDeviceOS,
  getQuerystring,
} from '../../../../assets/js/common-es6';

let centerResponse = [];

const markSelectInLinkIcon = getIcon(markSelectInLink, markSelectInLinkSize);
const markSelectTrostIcon = getIcon(markSelectTrost, markSelectInLinkSize);

const Marker = {
  markers: [],
  infoWindows: [],
  load: (centerParamData = []) => {
    console.log(centerParamData);
    Marker.destroy();
    Marker.spread(centerParamData);

    setMarkerEvent(Marker.markers, Marker.infoWindows);
  },
  destroy: () => {
    Marker.destroyMarker();
    Marker.destroyInfoWindow();

    Marker.markers = [];
    Marker.infoWindows = [];
  },
  destroyMarker: () => {
    if (Marker.markers && Marker.markers.length) {
      for (let i = 0, ii = Marker.markers.length; i < ii; i += 1) {
        Marker.markers[i].setMap(null);
        Marker.markers[i] = null;
      }

      Marker.markers = null;
    }
  },
  destroyInfoWindow: () => {
    if (Marker.infoWindows && Marker.infoWindows.length) {
      for (let i = 0, ii = Marker.infoWindows.length; i < ii; i += 1) {
        Marker.infoWindows[i].setMap(null);
        Marker.infoWindows[i] = null;
      }

      Marker.infoWindows = null;
    }
  },
  spread: (centerParamData = []) => {
    if (centerParamData.length) {
      centerResponse = centerParamData;
    }

    for (let i = 0, len = center.boundLength; i < len; i += 1) {
      const thisCenter = centerParamData[i];

      Marker.createMarker(i, thisCenter);
    }
  },
  createMarker: (idx, { mapX, mapY }) => {
    const latlng = new N.LatLng(mapY, mapX);
    let centerIcon = '';

    if (centerResponse) {
      if (
          centerResponse[idx]
          && (centerResponse[idx].isTrostPartnerCenter || centerResponse[idx].isContracted)
      ) {
        centerIcon = getIcon(markUnSelectTrost);
      } else {
        centerIcon = getIcon(markUnSelect);
      }
    }

    const marker = new N.Marker({
      map,
      position: latlng,
      clickable: true,
      icon: centerIcon,
    });

    Marker.markers.push(marker);
  },
  setMarkerSelectedCenter: (
    isNeedMark = 0,
    markID = null,
    mapX = 0,
    mapY = 0,
  ) => {
    const trostMarker = getQuerystring('isTrostMarker');
    const latlng = new N.LatLng(mapY, mapX);
    let centerIcon;

    if (isNeedMark || trostMarker === 'true') {
      centerIcon = markSelectTrostIcon;
    } else {
      centerIcon = getIcon(mapPinFocus, new N.Size(32, 42));
    }

    if (getQuerystring('mark') === undefined) {
      centerIcon = markSelectInLinkIcon;
    }

    if (getInfoOfDeviceOS() !== 'web') {
      map.setSize({ width: window.innerWidth, height: 200 });
    }

    map.goCenter(latlng, 15);

    const marker = new N.Marker({
      map,
      position: latlng,
      clickable: false,
      icon: centerIcon,
    });

    Marker.markers.push(marker);
  },
};

export default Marker;
